module.exports = __webpack_public_path__ + "img/junk3.bd9ac170.png";